import { MarketSegment } from '@/creditflowresearch/domain/Market/types/MarketSegment';

export const CORP_SEGMENT_ID = 'd70f44ee-b166-58b4-9966-43a286161e71';
export const FIG_SEGMENT_ID = '0c2da8ec-c154-58c1-ac50-ec9bcf14de0d';
export const SSA_SEGMENT_ID = '0ed3a35a-90cc-572e-a747-349a591d3b86';

export const SegmentIdByType: Record<MarketSegment, string> = {
  [MarketSegment.CORP]: CORP_SEGMENT_ID,
  [MarketSegment.FIG]: FIG_SEGMENT_ID,
  [MarketSegment.SSA]: SSA_SEGMENT_ID,
} as const;

export const SegmentTypeById: Record<string, MarketSegment> = {
  [CORP_SEGMENT_ID]: MarketSegment.CORP,
  [FIG_SEGMENT_ID]: MarketSegment.FIG,
  [SSA_SEGMENT_ID]: MarketSegment.SSA,
} as const;

export const CORPORATE_SEGMENTS: MarketSegment[] = [
  MarketSegment.CORP,
  MarketSegment.FIG,
  MarketSegment.SSA,
];

export const ABS_SEGMENTS: MarketSegment[] = [];

export const ALL_SEGMENT_IDS: string[] = [CORP_SEGMENT_ID, FIG_SEGMENT_ID, SSA_SEGMENT_ID];
